export enum OnboardingCompanyProgress {
  ONBOARDING = 1,
  READY_FOR_MARKUP = 2,
  AWAITING_APPROVAL = 3,
  COMPLETED = 4,
}
